/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Guides3IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Guides3Icon(props: Guides3IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 216 216"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeOpacity={".2"}
        d={
          "M201.03 54.288v107.423L108 215.423l-93.03-53.712V54.288L108 .576zM108.5.73V216M14.845 53.567l186.811 108m-186.581-.73 186.081-107.27"
        }
      ></path>
    </svg>
  );
}

export default Guides3Icon;
/* prettier-ignore-end */
